'use strict';

var util = require('../util/property-util');
var graphUtil = require('../util/graph-util');
var messageDiscriptors = require('../util/messageDiscriptors');
var MessageDescriptorConvertFactory = require('./messageDescriptorConvertFactory');

module.exports = /*@ngInject*/["ChartService", "LocaleFactory", function (ChartService, LocaleFactory) {
    var messageDescriptorConvertFactory = new MessageDescriptorConvertFactory();

    function MessageDataFactory() {
    }

    MessageDataFactory.prototype.getMessageData = function (messageName, criteria, callback, errorCallback) {
        var data;
        switch (messageName) {
            case "gpsData":
                data = ChartService.getGpsPositionData(criteria, function (newData) {
                    function isValid(value) {
                        return util.isDefined(value.valid) && value.valid;
                    }

                    callback(newData.filter(isValid));

                    newData.forEach(function (newDataEntry) {
                        formatSpeed(newDataEntry, LocaleFactory.isMetric());
                    });
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "trainUsers":
                data = ChartService.getTrainUserMessages(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "capacityTestData":
                data = ChartService.getCapacityTestData(criteria, function (newData) {
                    callback(newData.map(convertMbitsToKbits));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "virtualUser":
                data = ChartService.getVirtualUserMessages(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "allTrainUsers":
                data = ChartService.getCombinedTrainUserMessages(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "mar3LinkStatistics":
                data = ChartService.getMar3LinkStatisticsMessages(criteria, function (newData) {
                    callback(newData.map(formatLinkObject));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "mar3Congestion":
                data = ChartService.getMar3CongestionMessages(criteria, function (newData) {
                    callback(newData.map(formatLink));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "mar3LteStatistics":
                data = ChartService.getMar3LteStatisticsMessages(criteria, function (newData) {
                    callback(newData.map(formatLteObject));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "mar3GsmStatistics":
                data = ChartService.getMar3GsmStatisticsMessages(criteria, function (newData) {
                    callback(newData.map(formatGsmObject));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "mar3WcdmaStatistics":
                data = ChartService.getMar3WcdmaStatisticsMessages(criteria, function (newData) {
                    callback(newData.map(formatWcdmaObject));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "mar3LinkSessions":
                data = ChartService.getMar3LinkSessionsMessages(criteria, function (newData) {
                    callback(newData.map(formatLinkSessionObject));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "mar3CombinedLinkSessions":
                data = ChartService.getCombinedMar3LinkSession(criteria, function (newData) {
                    callback(newData);
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "mar3LinkCombined":
                data = ChartService.getMar3CombinedLinkStatisticsMessages(criteria, function (newData) {
                    callback(newData.map(formatLinkCombined));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "portalConsumptionCombined":
                data = ChartService.getCombinedPortalConsumption(criteria, function (newData) {
                    callback(newData);
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case "mar3SimStatistics":
                data = ChartService.getSimStatistics(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case 'connections':
                data = ChartService.getRadioUserCount(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case 'obisDeviceTemperature':
                data = ChartService.getObisDeviceTemperatureMessages(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case 'obisDeviceLifeSign':
                data = ChartService.getObisDeviceLifeSignMessages(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case 'obisDeviceLoopStatus':
                data = ChartService.getObisDeviceLoopStatusMessages(criteria, function (newData) {
                    callback(newData.map(formatObisLoopStatusObject));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                            errorCallback();
                        }
                });
                break;
            case 'obisDevicePSUDetails':
                data = ChartService.getObisDevicePSUDetailsMessages(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                            errorCallback();
                        }
                });
                break;
            case 'obisDevicePSUDetailsSummary':
                data = ChartService.getObisDevicePSUDetailsSummaryMessages(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                            errorCallback();
                        }
                });
                break;
            case 'obisDeviceSWPlatformStatus':
                data = ChartService.getObisDeviceSWPlatformStatusMessages(criteria,function (newData) {
                    callback(newData.map(formatObisDeviceSWPlatformStatusObject));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                            errorCallback();
                        }
                });
                break;
            case 'obisDeviceAssignedJourney':
                data = ChartService.getObisDeviceAssignedJourneyMessages(criteria,function (newData) {
                    callback(newData.map(formatJourneyIdObject));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case 'obisDeviceDegraded':
                data = ChartService.getObisDeviceDegradedMessages(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case 'obisMtsDownloadStatus':
                data = ChartService.getObisMtsDownloadStatusMessages(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case 'obisLine':
                data = ChartService.getObisLineMessages(criteria,function (newData) {
                    callback(newData.map(formatLineObject));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case 'obisDeviceOperationHours':
                data = ChartService.getObisDeviceOperationHoursMessages(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case 'obisTrainPosition':
                data = ChartService.getObisTrainPositionMessages(criteria,function (newData) {
                    callback(newData.map(formatTrainPositionObject));
                }).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
            case 'obisMmdBacklight':
                data = ChartService.getObisMmdBacklightMessages(criteria, callback).$promise.catch(function () {
                    if (util.isDefined(errorCallback)) {
                        errorCallback();
                    }
                });
                break;
        }
    };

    function formatSpeed(object, isMetric) {
        object.originalSpeed = object.speed;
        if (!isMetric) {
            object.speed = graphUtil.toMilesPerHour(object.speed);
        } else {
            object.speed = object.originalSpeed;
        }
    }

    function formatLinkObject(object) {
        object = formatLink(object);

        var interval = object.interval / 1000; // object.interval is defined in ms
        object.bitsSent = Math.round(object.bytesSent * 8 / interval);
        object.bitsReceived = Math.round(object.bytesReceived * 8 / interval);

        object.technology = messageDiscriptors.formatCellTechnology(object.accessTechnology);

        object.nType = messageDiscriptors.networkType2Index(object.networkType);
        object.mState = messageDescriptorConvertFactory.convertStringToIndex('modemState', object.modemState, "modemState");

        return object;
    }

    function formatLink(object) {
        object.link = formatMar3Link(object.link);
        return object;
    }

    function convertBitsToBytesForBandwidth(object) {
        object.bytesPerSecondReceived = object.bytesPerSecondReceived * 8;
        object.bytesPerSecondSend = object.bytesPerSecondSend * 8;
        return object;
    }

    function convertMbitsToKbits(object) {
        object.link = formatMar3Link(object.link);
        object.rateMbps = object.rateMbps * 1000;
        return object;
    }

    function formatLinkSessionObject(object) {
        object.link = formatMar3Link(object.link);
        return object;
    }


    function formatMar3Link(link) {
        if (util.containsText(link, "CELL")) {
            link = "MODEM_" + link.split('_')[1];
        }
        return link;
    }

    function formatLinkCombined(object) {
        return object;
    }

    function formatLteObject(object) {
        object.link = formatMar3Link(object.link);
        object.lteBand = messageDescriptorConvertFactory.convertStringToIndex('band', object.lteBand, "lteBand");
        object.emm = messageDescriptorConvertFactory.convertStringToIndex('emm', object.emmState, "emm");
        object.service = messageDescriptorConvertFactory.convertStringToIndex('service', object.serviceState, "service");
        object.rrc = messageDescriptorConvertFactory.convertStringToIndex('rrc', object.rrcState, "rrc");
        object.imsReg = messageDescriptorConvertFactory.convertStringToIndex('ims', object.imsRegState, "imsReg");
        object.caState = messageDescriptorConvertFactory.convertStringToIndex('caState', object.imsRegState, "caState");
        return object;
    }

    function formatGsmObject(object) {
        object.link = formatMar3Link(object.link);
        object.gsmBand = messageDescriptorConvertFactory.convertStringToIndex('band', object.gsmBand, "gsmBand");
        object.gmm = messageDescriptorConvertFactory.convertStringToIndex('gmm', object.gmmState, "gmm");
        object.plmn1 = messageDescriptorConvertFactory.convertStringToIndex('plmn', object.plmnState1, "plmn1");
        object.plmn2 = messageDescriptorConvertFactory.convertStringToIndex('plmn', object.plmnState2, "plmn2");
        object.mm = messageDescriptorConvertFactory.convertStringToIndex('mm', object.mmState, "mm");
        object.gprs = messageDescriptorConvertFactory.convertStringToIndex('gprs', object.gprsState, "gprs");
        object.servingCellBandFormatted = messageDescriptorConvertFactory.convertStringToIndex('servingCell', object.servingCellBand, "servingCellBandFormatted");
        return object;
    }

    function formatWcdmaObject(object) {
        object.link = formatMar3Link(object.link);
        object.wcdmaBand = messageDescriptorConvertFactory.convertStringToIndex('band', object.wcdmaBand, "wcdmaBand");
        object.gmm = messageDescriptorConvertFactory.convertStringToIndex('gmm', object.gmmState, "gmm");
        object.plmn1 = messageDescriptorConvertFactory.convertStringToIndex('plmn', object.plmnState1, "plmn1");
        object.plmn2 = messageDescriptorConvertFactory.convertStringToIndex('plmn', object.plmnState2, "plmn2");
        object.mm = messageDescriptorConvertFactory.convertStringToIndex('mm', object.mmState, "mm");
        object.wcdmal1 = messageDescriptorConvertFactory.convertStringToIndex('l1', object.wcdmaL1State, "wcdmal1");
        object.rrc = messageDescriptorConvertFactory.convertStringToIndex('rrc', object.rrcState, "rrc");
        return object;
    }


    function formatObisLoopStatusObject(object) {
        object.indexCategory = messageDescriptorConvertFactory.convertStringToIndex('category', object.category, "category");
        return object;
    }

    function formatJourneyIdObject(object) {
        object.indexJourneyCode = messageDescriptorConvertFactory.convertStringToIndex('journeyCode', object.journeyCode, "journeyCode");
        return object;
    }

    function formatLineObject(object) {
        object.indexName = messageDescriptorConvertFactory.convertStringToIndex('name', object.name, "name");
        return object;
    }

    function formatTrainPositionObject(object) {
        object.indexTp = messageDescriptorConvertFactory.convertStringToIndex('tp', object.tp, "tp");
        object.indexNextStopCode = messageDescriptorConvertFactory.convertStringToIndex('nextStopCode', object.nextStopCode, "nextStopCode");
        object.indexNextStopName = messageDescriptorConvertFactory.convertStringToIndex('nextStopName', object.nextStopName, "nextStopName");
        return object;
    }

    function formatObisDeviceSWPlatformStatusObject(object) {
        object.indexCode = messageDescriptorConvertFactory.convertStringToIndex('code', object.code, "code");
        return object
    }

    return new MessageDataFactory();
}];